import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './TeamJoin.css';

const API_BASE = process.env.REACT_APP_API_URL || '';

const TeamJoin: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Check if code was passed in URL
  useEffect(() => {
    const codeParam = searchParams.get('code');
    if (codeParam) {
      setCode(codeParam.toUpperCase());
      handleJoin(codeParam.toUpperCase());
    }
  }, [searchParams]);

  const handleJoin = async (joinCode?: string) => {
    const codeToUse = (joinCode || code).toUpperCase().trim();
    
    if (codeToUse.length !== 6) {
      setError('Voer een code van 6 tekens in');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_BASE}/api/team-app/join/${codeToUse}`);
      const data = await response.json();

      if (response.ok && data.success) {
        // Store team info in localStorage for persistence
        localStorage.setItem('teamApp', JSON.stringify({
          joinCode: codeToUse,
          teamId: data.teamId,
          teamName: data.teamName,
          eventId: data.eventId,
          eventName: data.eventName
        }));
        
        // Navigate to team view
        navigate(`/team/${codeToUse}`);
      } else {
        setError(data.error || 'Ongeldige code');
      }
    } catch (err) {
      setError('Kan niet verbinden met de server');
    } finally {
      setLoading(false);
    }
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (value.length <= 6) {
      setCode(value);
      setError('');
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleJoin();
  };

  return (
    <div className="team-join-container">
      <div className="team-join-card">
        <div className="team-join-logo">
          <span className="logo-icon">🎵</span>
          <h1>Hitster</h1>
        </div>
        
        <h2>Team App</h2>
        <p className="team-join-subtitle">Voer je teamcode in om mee te doen</p>
        
        <form onSubmit={handleSubmit} className="team-join-form">
          <div className="code-input-container">
            <input
              type="text"
              value={code}
              onChange={handleCodeChange}
              placeholder="ABC123"
              className="code-input"
              maxLength={6}
              autoFocus
              autoComplete="off"
              autoCapitalize="characters"
            />
          </div>
          
          {error && <div className="team-join-error">{error}</div>}
          
          <button 
            type="submit" 
            className="team-join-button"
            disabled={loading || code.length !== 6}
          >
            {loading ? 'Bezig...' : 'Deelnemen'}
          </button>
        </form>
        
        <p className="team-join-help">
          Vraag de spelleider om je teamcode
        </p>
      </div>
    </div>
  );
};

export default TeamJoin;
